import React from "react";
import { Row, Col, Container, Media } from "reactstrap";
import Slider from "react-slick";
import myImage from '../../../resources/custom/images/customer_testimonial.jpg';

var settings = {
  autoplay: false,
  autoplaySpeed: 2500,
};

const Review = [
  {
    img: "/images/testimonial/1.jpg",
    user: "Rahul K",
    review:
    "I am absolutely in love with the unique and exquisite handicrafts from Parijat! The attention to detail and craftsmanship of each piece is remarkable. My home has been transformed into a haven of artistic elegance, thanks to Parijat Handicrafts.",
  },
  {
    img: "/images/testimonial/2.jpg",
    user: "Amit G",
    review:
    "I recently made a purchase from Parijat Handicrafts, and I couldn't be happier with the quality of the product and the overall shopping experience. The website is user-friendly, and the products exceeded my expectations. Will definitely be coming back for more!",
  },
  {
    img: "/images/testimonial/3.jpg",
    user: "Sumit G",
    review:
    "Parijat Handicrafts has an incredible collection of handwoven textiles. The colors and patterns are so vibrant and unique. I purchased a couple of throws for my living room, and they have added a touch of warmth and style to my home. Highly recommended!",
  },
];
const CustomerTestimonial = () => {
  return (
    <>
      <section className="testimonial testimonial-inverse">
        <Container>
          <Row>
            <Col md="12">
              <div className="slide-1 no-arrow">
                <Slider {...settings}>
                  {Review.map((data, i) => (
                    <div key={i}>
                      <div className="testimonial-contain">
                        <div className="media">
                          <div className="testimonial-img">
                            <Media src={myImage} className="img-fluid rounded-circle" alt="testimonial" />
                          </div>
                          <div className="media-body">
                            <h5>{data.user}</h5>
                            <p>{data.review}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default CustomerTestimonial;
